import React from "react";

import FeaturedProjectCard from "./FeaturedProjectCard";
import ProjectsListPage from "./ProjectsListPage";

import localize from "lang/localize";

class FeaturedProjectsPage extends ProjectsListPage {
  renderProjects() {
    const projects = this.props.projects;
    return projects.map((project, index) => (
      <FeaturedProjectCard
        key={index}
        text={project.title}
        img={project.bannerImage}
        id={project.id}
        description={project.description}
        project={project}
        language={this.props.language}
      />
    ));
  }

  render() {
    return (
      <div className="projects-list container verticalpadding">
        <div className="project-cards-wrapper">
          <div className="project-card-container">
            <h4>
              {localize("nav_bar_title_sub_featured", this.props.language)}
            </h4>
          </div>
        </div>
        <div>
          {this.renderProjects()}
          {this.props.more && (
            <div className="innerblock project-cards-wrapper">
              <div className="more-button-container">
                <button
                  className="button automargin"
                  onClick={this.props.handleMore}
                >
                  {localize("more_text", this.props.language)}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default FeaturedProjectsPage;
